import React from 'react';
import moment from 'moment';

import { successBackground, alertBackground } from 'src/styles/colors';
import { dollars } from 'src/utils/stringHelpers';
import {
  BidStatusBox,
  BidStatusRow,
  BidStatusHeadline,
  BidStatusPrice,
  BidStatusDetail,
  BidStatusTimestamp,
} from './elements';

// A bidder's own bid is theirs to see; the leader's max stays hidden from
// everyone else, so the headline figure is always the effective price.
const ownBidLabel = (myPreBid, leading) => {
  if (!leading) { return 'Your highest bid'; }

  return 'Max' === myPreBid.type ? 'Your max bid' : 'Your bid';
};

const BidStatusBanner = ({ preBidData, fetchedAt }) => {
  const currentPrice = preBidData?.highPreBidPrice;

  // A lot with no pre-bids reports null. Zero is a real price on lots whose
  // start price is zero, so it has to survive this guard.
  if (currentPrice == null) { return null; }

  const myPreBid = preBidData.myPreBid;
  const leading = !!myPreBid && preBidData.highPreBid?.id === myPreBid.id;

  let background;
  let headline;

  if (leading) {
    background = successBackground;
    headline = 'You have the highest bid';
  } else if (myPreBid) {
    background = alertBackground;
    headline = 'You have been outbid';
  }

  const timestamp = fetchedAt && (
    <BidStatusTimestamp>
      {`Updated at ${moment(fetchedAt).format('h:mm A')}`}
    </BidStatusTimestamp>
  );

  // With no bid of their own there is no second line, so the stamp rides up
  // beside the price instead of leaving a row holding nothing else.
  return (
    <BidStatusBox $background={background} data-testid="bid-status">
      <BidStatusRow>
        <BidStatusPrice>
          {`Current Pre-Bid: ${dollars(currentPrice)}`}
        </BidStatusPrice>
        {myPreBid ? <BidStatusHeadline>{headline}</BidStatusHeadline> : timestamp}
      </BidStatusRow>

      {myPreBid && (
        <BidStatusRow>
          <BidStatusDetail>
            {`${ownBidLabel(myPreBid, leading)}: ${dollars(myPreBid.price)}`}
          </BidStatusDetail>
          {timestamp}
        </BidStatusRow>
      )}
    </BidStatusBox>
  );
};

export default BidStatusBanner;
